export default "__VITE_ASSET__BAKBMavn__"